export default __webpack_public_path__ + "static/louhei-ebb2835321bb20352db1200ea1079575.png";